/** True when `content` is a lone image/GIF URL from a trusted host (Giphy). */
export function isSupportChatMediaUrl(content) {
    const trimmed = content.trim();
    if (!trimmed || /\s/.test(trimmed))
        return false;
    try {
        const url = new URL(trimmed);
        if (!/^https?:$/i.test(url.protocol))
            return false;
        return /(^|\.)giphy\.com$/i.test(url.hostname);
    }
    catch {
        return false;
    }
}
/** Matches the BO (operator panel) frontend's rule for a trailing Giphy GIF URL. */
function isTrailingGiphyGifUrl(candidate) {
    if (!candidate || /\s/.test(candidate) || !candidate.startsWith('https://'))
        return false;
    let url;
    try {
        url = new URL(candidate);
    }
    catch {
        return false;
    }
    return /(^|\.)giphy\.com$/i.test(url.hostname);
}
/**
 * The backend has no separate GIF field — a GIF is the trailing line of `content`.
 * Falls back to the legacy lone-URL check when `content` is nothing but a URL.
 */
export function splitSupportChatMessageContent(content) {
    const lines = content.split('\n');
    const lastLine = (lines.at(-1) ?? '').trim();
    if (isTrailingGiphyGifUrl(lastLine)) {
        return { text: lines.slice(0, -1).join('\n').trim(), gifUrl: lastLine };
    }
    if (lines.length === 1 && isSupportChatMediaUrl(lastLine)) {
        return { text: '', gifUrl: lastLine };
    }
    return { text: content, gifUrl: null };
}
